import React, { useContext, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { Translate, Localize, getLocale, setLocale } from "react-i18nify";

import { useTheme, createTheme, ThemeProvider } from "@mui/material/styles";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";

import { WORKFLOW_MODES } from "../../../../constants";

import { StepConnector } from "@mui/material";
import { colors } from "@mui/material";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = mainColor => augmentColor({ color: { main: mainColor } });

// props has activeStep
export default function KioskStepper({
  activeStep,
  workflowmode,
  backUrl,
  getKioskConfiguration,
  enableBackFunctionOverwrite,
  backFunction
}) {
  const navigate = useNavigate();

  const [steps, setSteps] = useState(["", "", ""]);

  // workflowmode should work as well, can refactor to this if needed
  // useEffect(() => {
  //   if (props.workflowmode == "bag") {
  //     setSteps(["", "", ""]);
  //   } else {
  //     setSteps(["", "", "", ""]);
  //   }
  // }, []);
  useEffect(() => {
    const kioskconfig = getKioskConfiguration();
    if (kioskconfig == null) {
      return;
    }

    let kc_workflowmode = kioskconfig.workflowMode;

    switch (kc_workflowmode) {
      case WORKFLOW_MODES.BAG_ONLY_WITH_AUTH:
      case WORKFLOW_MODES.BAG_ONLY:
        setSteps(["", "", ""]);
        break;
      default:
        setSteps(["", "", "", ""]);
        break;
    }
  }, []);

  const pressBack = () => {
    if (enableBackFunctionOverwrite) {
      backFunction();
      return;
    }

    if (backUrl !== undefined) {
      navigate(backUrl);
    }
  };

  const pressEnd = () => {
    const kiosktheme = getKioskTheme();
    if (kiosktheme.bilingual) {
      setLocale("fr");
    }

    navigate("/language");
  };

  const { getKioskTheme } = useContext(SocketIOContext);

  const theme = useTheme();
  const kioskTheme = getKioskTheme();
  const steppertheme = createTheme(theme, {
    primary: createColor("#000000"),
    secondary: colors.pink,
    components: {
      MuiButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              minWidth: "0px" //Fix for scaling button on higher res
            }
          })
        }
      },
      // MuiButtonBase: {
      //   styleOverrides: {
      //     root: ({ ownerState }) => ({
      //       ...{
      //         backgroundColor: ""
      //       }
      //     })
      //   }
      // },
      MuiStepIcon: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              width: "3.2vh",
              height: "3.2vh",

              //backgroundColor: "white",
              //color: "rgba(0,0,0,0)",
              "&.Mui-active": {
                color: kioskTheme.stepperStepBGColor, //Stepper BG Color
                width: "3.2vh",
                height: "3.2vh",

                "& .MuiStepIcon-text": {
                  //fill: kioskTheme.stepperStepTextColor
                }
              },
              "&.Mui-completed": {
                //backgroundColor: "white"
                color: kioskTheme.stepperStepBGColor //Stepper BG Color
              }
            }
          }),
          text: ({ ownerState }) => ({
            ...{
              //fill: "black" //Text color of future step
              // //fontSize: "2vh"
              // "&.Mui-active": {
              //   fill: "white"
              // }
            }
          })
        }
      },
      MuiStepConnector: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              "&.Mui-disabled": {
                opacity: 0
              }
            }
          }),
          line: ({ ownerState }) => ({
            ...{
              borderColor: "black",
              "&.Mui-disabled": {
                opacity: 0
              }
            }
          })
        }
      },
      MuiStep: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{ display: "flex" }
          })
        }
      },
      MuiStepButton: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              // padding: 16px 24px;
              // margin: -16px -24px;

              padding: "0 0",
              margin: "0 0"
            }
          })
        }
      },
      MuiStepLabel: {
        styleOverrides: {
          iconContainer: ({ ownerState }) => ({
            ...{
              paddingRight: "0"
            }
          })
        }
      }
    }
  });

  const kioskstyles = useKioskHorizontalStyles();

  return (
    <div
      style={{
        maxWidth: "608px", //Same as blackCornedDiv
        // width: "41vw" //TODO: use minWidth, if mobile
        //width: "34vw" //TODO: use minWidth, if mobile
        width: "100%"
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <Button
          variant="contained"
          disabled={backUrl == undefined}
          onClick={pressBack}
          style={kioskstyles.StepperButtonBack}
        >
          {/* &nbsp; &nbsp; */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "-0.5vh"
            }}
          >
            <KeyboardBackspaceIcon
              style={{
                marginRight: "1vh",
                fontSize: "2vh",
                marginTop: "0.3vh"
              }}
            />
            <span class="fontSecondaryText" style={{ height: "100%" }}>
              <Translate value="application.theme.footerBackText" />
            </span>
          </div>
        </Button>
        <ThemeProvider theme={steppertheme}>
          <Stepper
            activeStep={activeStep}
            style={{ width: "50%", paddingLeft: "8px", paddingRight: "8px" }}
            connector={<StepConnector />}
          >
            {steps.map((label, index) => (
              <Step
                key={index}
                style={{ paddingLeft: "0px", paddingRight: "0px" }}
              >
                <StepButton color="inherit" style={{}}>
                  {label}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </ThemeProvider>
        <Button
          variant="contained"
          onClick={pressEnd}
          style={kioskstyles.StepperButtonEnd}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "-0.5vh"
            }}
          >
            <CancelIcon //fontSize="small"
              style={{
                marginRight: "1vh",
                fontSize: "2vh",
                marginTop: "0.3vh"
              }}
            />
            <span class="fontSecondaryText" style={{ height: "100%" }}>
              <Translate value="application.theme.footerEndText" />
            </span>
          </div>
        </Button>
      </Box>
    </div>
  );
}
